// material
import { alpha, useTheme } from '@mui/material/styles';
import { GlobalStyles as GlobalThemeStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const theme = useTheme();

  return (
    <GlobalThemeStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch'
        },
        body: {
          width: '100%',
          height: '100%',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.default,
          backgroundImage: theme.palette.gradients.dashboardCanvas,
          backgroundAttachment: 'fixed',
          '--zy-text-muted': theme.palette.text.secondary,
          '--zy-border-subtle': alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.1 : 0.35),
          '--zy-border-strong': alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.25 : 0.65),
          '--zy-chip-checked-bg': theme.palette.success.main,
          '--zy-chip-checked-text': theme.palette.getContrastText(theme.palette.success.main),
          '--zy-chip-shadow': theme.palette.mode === 'light'
            ? '0 1px 4px 0 rgba(13, 23, 38, 0.15)'
            : '0 1px 4px 0 rgba(0, 0, 0, 0.6)',
          '--zy-status-active-bg': theme.palette.success.main,
          '--zy-status-inactive-bg': theme.palette.error.main,
          '--zy-status-text': theme.palette.common.white,
          '--zy-hero-gradient': theme.palette.gradients.layout
        },
        '#root': {
          width: '100%',
          height: '100%'
        },
        a: {
          color: theme.palette.brand.link,
          fontWeight: theme.palette.mode === 'dark' ? 600 : 500,
          textDecoration: 'none',
          textUnderlineOffset: '4px',
          transition: 'color 160ms ease, text-decoration 160ms ease',
          '&:hover': {
            color: theme.palette.brand.linkHover,
            textDecoration: 'underline'
          }
        },
        '.brand-gradient-text': {
          backgroundImage: theme.palette.gradients.logo,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textFillColor: 'transparent'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            }
          }
        },
        textarea: {
          '&::-webkit-input-placeholder': {
            color: theme.palette.text.disabled
          },
          '&::-moz-placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled
          },
          '&:-ms-input-placeholder': {
            color: theme.palette.text.disabled
          },
          '&::placeholder': {
            color: theme.palette.text.disabled
          }
        },

        img: { display: 'block', maxWidth: '100%' },

        // Lazy Load Img
        '.blur-up': {
          WebkitFilter: 'blur(5px)',
          filter: 'blur(5px)',
          transition: 'filter 400ms, -webkit-filter 400ms'
        },
        '.blur-up.lazyloaded ': {
          WebkitFilter: 'blur(0)',
          filter: 'blur(0)'
        }
      }}
    />
  );
}
